import { Scale } from "../../../utils/Scale"

export class EcigTourPos {
    static skipButtonX = () => Scale.width() * 0.65
    static skipButtonY = () => Scale.height() * 0.05

    static bottomLeftNoteX = () => Scale.width() * 0.1
    static bottomLeftNoteY = () => Scale.height() * 0.54

    static acetalehydeX = () => Scale.width() * 0.15
    static acetalehydeY = () => Scale.height() * 0.1

    static nicotineX = () => Scale.width() * 0.6
    static nicotineY = () => Scale.height() * 0.1

    static leadX = () => Scale.width() * 0.6
    static leadY = () => Scale.height() * 0.6

    static cadmiumX = () => Scale.width() * 0.2
    static cadmiumY = () => Scale.height() * 0.65

    static nicotineNoteX = () => Scale.width() * 0.4
    static nicotineNoteY = () => Scale.height() * 0.02

    static nicotineX2 = () => Scale.width() * 0.09
    static nicotineY2 = () => Scale.height() * 0.18

    static propyleneGlycolX = () => Scale.width() * 0.4
    static propyleneGlycolY = () => Scale.height() * 0.4

    static propyleneGlycolX2 = () => Scale.width() * 0.09
    static propyleneGlycolY2 = () => Scale.height() * 0.2

    static moleculeLocation1X = () => Scale.width() * 0.6
    static moleculeLocationY = () => Scale.height() * 0.04

    static letsReviewX = () => Scale.width() * 0.1
    static letsReviewY = () => Scale.height() * 0.5

    static clickAnswerY = () => Scale.height() * 0.1
}
